<template>
    <div class="detail">
        <el-dialog title="商品详情" :visible.sync="dialogVisible" width="996px" :before-close="handleClose">
            <div class="content" v-loading="load">
                <el-table ref="singleTable" :data="tableDataD" style="width: 100%" @selection-change="handleSelectionChange" border >
                    <el-table-column type="selection" width="55" v-if="type == 2" :selectable="checkSelect"> </el-table-column>
                    <el-table-column prop="id" label="商品ID" width="80" align="center"> </el-table-column>
                    <el-table-column prop="tits" label="商品名称" width="180" align="center">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.tits && scope.row.tits.length > 8" :content="scope.row.tits" placement="top" effect="light">
                                <span>{{ scope.row.tits | countFmt }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.tits | countFmt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_specifications_type_id" label="规格类型" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.goods_specifications_type_id == 1 ? "单规格" : "多规格" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="商品规格(sku)" align="center" width="180px">
                        <template slot-scope="scope">
                            {{ scope.row.title || "-" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="销售价" align="center">
                        <template slot-scope="scope">
                            <p>{{ scope.row.prices_mains }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchandise_inventory" label="库存" align="center"> </el-table-column>
                    <el-table-column prop="retail_price" label="返现比例或现金" align="center" width="280px" v-if="params_type == 'activity_share_product' || params_type == 'activity_link_product'">
                        <template slot-scope="scope">
                            <div class="price">
                                <el-input
                                    v-model="scope.row.reward_share"
                                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                                    size="small"
                                >
                                    <template slot="append">%</template>
                                </el-input>
                                <el-input
                                    v-model="scope.row.reward_cash"
                                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                                    size="small"
                                >
                                    <template slot="append">元</template>
                                </el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="拼团价" align="center" width="140px" v-if="params_type == 'activity_team_product'">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.price" size="small">
                                <template slot="append">元</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="leader_price" label="团长价" align="center" width="140px" v-if="params_type == 'activity_team_product' && is_open_leader_price == 1">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.leader_price" size="small">
                                <template slot="append">元</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activityPrice" label="起购价" align="center" width="140px" v-if="params_type == 'activity_link_product' && sellType == 2">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.activityPrice" size="small">
                                <template slot="append">元</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="repertory" label="活动库存" width="160" align="center">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.total_stock" style="width: 120px" :min="0" :max="Number(scope.row.merchandise_inventory)"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <div>
                    <el-button type="primary" @click="postDetailData" plain>确 定</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            tableDataD: [],
            load: false,
            multipleSelection: [],
            checkCount: 0,
            row: null,
        };
    },
    props: {
        type: {
            type: Number,
            default: 1,
        },
        params_type: {
            type: String,
            default: "",
        },
        is_open_leader_price: {
            type: Number,
            default: 1,
        },
        sellType: {
            type: Number,
            default: 1,
        },
    },
    filters: {
        countFmt(val) {
            if (val) {
                if (val.length >= 8) {
                    return val.substring(0, 8) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {},
    methods: {
        checkSelect(row, index) {
            if (row.activity_name == "") {
                // 判断里面是否存在某个参数
                return 1;
            } else {
                return 0;
            }
        },
        // 获取多规格列表数据并已选
        bindData(data) {
            console.log(data);
            this.checkCount = 0;
            this.tableDataD = data;
            this.row = data;
            if (this.tableDataD && this.tableDataD.length > 0) {
                this.$nextTick(() => {
                    this.tableDataD.forEach((item, index) => {
                        if (item.checked) {
                            this.checkCount += 1;
                            this.$refs.singleTable.toggleRowSelection(item, true);
                        }
                    });
                });
            }
        },
        // 选择多规格商品
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (this.tableDataD && this.tableDataD.length > 0) {
                this.$nextTick(() => {
                    this.tableDataD.forEach((val) => {
                        val.checked = false;
                    });
                    this.multipleSelection.forEach((item) => {
                        item.checked = true;
                    });
                });
            }
        },
        // 关闭
        handleClose() {
            this.dialogVisible = false;
            this.tableDataD = [];
            this.multipleSelection = [];
        },
        // 选择商品后处理数据
        postDetailData() {
            let arr;
            switch (this.params_type) {
                case "activity_share_product":
                    if (this.type == 1) {
                        let f = this.tableDataD.some((item) => {
                            return !item.reward_share && !item.reward_cash && item.reward_cash <= item.prices_mains;
                        });
                        let t = this.tableDataD.some((item) => {
                            return !item.total_stock;
                        });
                        if (f || t) {
                            return this.$message.warning("请填写库存或返现金额!");
                        }
                        arr = JSON.parse(JSON.stringify(this.tableDataD));
                    } else {
                        let f = this.multipleSelection.some((item) => {
                            return !item.reward_share && !item.reward_cash && item.reward_cash <= item.prices_mains;
                        });
                        let t = this.multipleSelection.some((item) => {
                            return !item.total_stock;
                        });
                        if (f || t) {
                            return this.$message.warning("请填写库存或返现金额!");
                        }
                        arr = JSON.parse(JSON.stringify(this.multipleSelection));
                    }
                    break;
                case "activity_team_product":
                    if (this.type == 1) {
                        let f = this.tableDataD.some((item) => {
                            return !item.price || item.price >= item.prices_mains;
                        });
                        let l;
                        if (this.is_open_leader_price == 1) {
                            l = this.tableDataD.some((item) => {
                                return !item.leader_price || item.leader_price >= item.price;
                            });
                        }
                        let t = this.tableDataD.some((item) => {
                            return !item.total_stock;
                        });
                        if (f || t || l) {
                            return this.$message.warning("请填写金额(拼团价小于销售价，团长价小于拼团价)");
                        }
                        arr = JSON.parse(JSON.stringify(this.tableDataD));
                    } else {
                        let f = this.multipleSelection.some((item) => {
                            return !item.price || item.price >= item.prices_mains;
                        });
                        let l;
                        if (this.is_open_leader_price == 1) {
                            l = this.multipleSelection.some((item) => {
                                return !item.leader_price || item.leader_price >= item.price;
                            });
                        }
                        let t = this.multipleSelection.some((item) => {
                            return !item.total_stock;
                        });
                        if (f || t || l) {
                            return this.$message.warning("请填写库存或金额且金额要小于销售价!");
                        }
                        arr = JSON.parse(JSON.stringify(this.multipleSelection));
                    }
                    break;
                case "activity_link_product":
                    if (this.type == 1) {
                        let f = this.tableDataD.some((item) => {
                            return !item.reward_share && !item.reward_cash && item.reward_cash <= item.prices_mains;
                        });
                        let l;
                        if (this.sellType == 2) {
                            l = this.tableDataD.some((item) => {
                                return !item.activityPrice;
                            });
                        }
                        let t = this.tableDataD.some((item) => {
                            return !item.total_stock;
                        });
                        if (f || t || l) {
                            return this.$message.warning("请填写库存或返现金额!");
                        }
                        arr = JSON.parse(JSON.stringify(this.tableDataD));
                    } else {
                        let f = this.multipleSelection.some((item) => {
                            return !item.reward_share && !item.reward_cash && item.reward_cash <= item.prices_mains;
                        });
                        let l;
                        if (this.sellType == 2) {
                            l = this.multipleSelection.some((item) => {
                                return !item.activityPrice;
                            });
                        }
                        let t = this.multipleSelection.some((item) => {
                            return !item.total_stock;
                        });
                        if (f || t || l) {
                            return this.$message.warning("请填写库存或返现金额!");
                        }
                        arr = JSON.parse(JSON.stringify(this.multipleSelection));
                    }
                    break;
                default:
                    break;
            }
            this.$emit("postDetailData", arr, this.type, this.tableDataD);
            this.tableDataD = [];
            this.dialogVisible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.detail {
    .content {
        ::v-deep .el-table__body-wrapper {
            height: 400px !important;
            overflow-y: auto;
        }
    }
    ::v-deep .el-table__body-wrapper {
        border-bottom: none;
    }
    ::v-deep .el-table::before {
        display: none;
    }
    ::v-deep .el-input-number {
        width: 140px;
    }
}
.price {
    display: flex;
    justify-content: space-between;
    .el-input-group {
        width: 48%;
    }
}
</style>